import { useQuery } from 'react-query'
import { Loader } from './_shared/Loader'
import { getInsuranceInformation } from '../../../../api/newApi'
import { useChosenCompany, useUser } from '../../../../context/UserProvider'

export function CarInsuranceDetails({ id }: { id: string }) {
  const company = useChosenCompany()
  const user = useUser()
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['insurance-card', id],
    queryFn: () =>
      getInsuranceInformation({
        accountNo: id,
        companyId: company?.id,
        contactId: user?.user.id,
      }),
  })

  if (isLoading) {
    return (
      <div className="w-full min-h-[120px] flex items-center justify-center">
        <Loader />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="w-full min-h-[120px] flex-col flex gap-2 items-center justify-center">
        <p className="text-red-500">Obs! Noe gikk galt.</p>
        <button className="hover:underline" onClick={() => refetch()}>
          Prøv på nytt
        </button>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 bg-white rounded-lg p-2 fade-in">
      {data?.code && <h3 className=" text-xl">{data?.code}</h3>}
      {data?.homepage && (
        <div className="flex items-center gap-2">
          <p>Hjemmeside: </p>
          <a className="text-old-primary hover:underline" href={data.homepage}>
            {data.homepage}
          </a>
        </div>
      )}
      {!(data?.code || data?.homepage) && <p className="text-gray-500">Ingen forsikringsinformasjon tilgjengelig</p>}
    </div>
  )
}

export function CarInsuranceDetailsItem({ title, data }: { title: string; data: string }) {
  return (
    <dl>
      <dt className="font-bold text-black">{title}</dt>
      <dd className="text-old-offGrey">{data}</dd>
    </dl>
  )
}
